<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/logo.jpeg" class="logo" @click="redirect">
    <!-- Use router-view to render components based on the route -->
    <router-view :uuid="uuid" />
  </div>
</template>

<script>
//import VehicleWarranty from './components/VehicleWarranty.vue';

export default {
  name: 'App',
  components: {
    //VehicleWarranty
  },
  data() {
    return {
      uuid: null  // Initialize uuid with a default value
    };
  },
  created() {
    // Check if the route has a uuid parameter and assign it to the data property
    if (this.$route.params.uuid) {
      this.uuid = this.$route.params.uuid;
    }
  },
  methods: {
    redirect() {
      window.location.href = 'https://hocan.com/';
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.logo {
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}

.logo:hover {
  cursor: pointer;
}
</style>
